package com.neurobs.ccabserver.transcriptreviewadmin.states

import com.neurobs.ccab.db.EventData
import com.neurobs.js.ccab.LogServer
import com.neurobs.js.util.ServerResponseUtil
import com.neurobs.react.{GenericState, GenericStateGenerator, ServerDataAttribute, StateAttribute}
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.Hooks._
import slinky.core.facade.ReactElement

case class S3SyncSelectionState (
  startEventsState: ServerDataAttribute[List[EventData]],
  displayedStartEventsState: StateAttribute[List[EventData]]
                       ) extends GenericState {

  def displayStartEvent(startEvent: EventData) = {
    if (!startEventIsDisplayed(startEvent)) {
      displayedStartEventsState.setValue(displayedStartEventsState.value :+ startEvent)
    }
  }

  def hideStartEvent(startEvent: EventData) = {
    if (startEventIsDisplayed(startEvent)) {
      displayedStartEventsState.setValue(displayedStartEventsState.value.filterNot(_.id == startEvent.id))
    }
  }

  def startEventIsDisplayed(startEvent: EventData) = displayedStartEventsState.value.exists(_.id == startEvent.id)

  def loadServerStartEvents() = {
    LogServer.getS3SyncStartEvents(handleServerStartEvents)
  }

  def handleServerStartEvents = ServerResponseUtil.handleObjectResultResponse[Seq[EventData]](
    handleObject = data => startEventsState.setData(data.sortBy(_.createdAt.instant.getEpochSecond).reverse.toList),
    onAnyError = startEventsState.setError(_)
  )
}

object S3SyncSelectionStateGenerator extends GenericStateGenerator[S3SyncSelectionState] {

  override def generateEmptyDefaultState(): S3SyncSelectionState = S3SyncSelectionState(
    emptyServerDataState[List[EventData]](),
    emptyDefaultState(List[EventData]()),
  )
}

@react
object S3SyncSelectionStateProvider {
  case class Props(children: ReactElement*)
  val component = FunctionalComponent[Props] { props =>

    val startEventsState = ServerDataAttribute(useState[Either[Option[String], List[EventData]]](Left(None)))
    val displayedStartEventsState = StateAttribute(useState(List[EventData]()))

    val s3SyncSelectionState = S3SyncSelectionState(
      startEventsState = startEventsState,
      displayedStartEventsState = displayedStartEventsState
    )

    useEffect(() => {
      s3SyncSelectionState.loadServerStartEvents()
    }, Vector())

    S3SyncSelectionStateGenerator.Provider(s3SyncSelectionState)(
      props.children:_*
    )

  }
}
